import { MainLayoutContainer } from "components/Layout";
import { useRequirementDetail } from "./useRequirementDetail";
import {
  Box,
  Stack,
  Typography,
  Grid2 as Grid,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import { ResponsiveButtonLink } from "components/Button";
import { CardOutline } from "components/Card";
import { DomainColorSquares, RequirementBox } from "components/Requirements";
import { BREADCRUMB_PAGE } from "components/Breadcrumb/constants";
import { ROLES } from "types/user";

export const ITERDetail = () => {
  const {
    requirement,
    competencies,
    role,
    isOrgView,
    organizationId,
  } = useRequirementDetail();
  if (!requirement) {
    return <div>loading...</div>;
  }
  return (
    <MainLayoutContainer
      title={requirement.name}
      breadcrumb={
        isOrgView
          ? BREADCRUMB_PAGE.ORGANIZATION_REQUIREMENT_ITERS
          : role === ROLES.ADMIN
            ? BREADCRUMB_PAGE.ITER_LIST
            : BREADCRUMB_PAGE.REQUIREMENT_PORTAL
      }
      buttonActions={
        <Stack direction="row" spacing={2} alignItems="center">
          {(role === ROLES.ADMIN ||
            role === ROLES.DIRECTOR ||
            role === ROLES.MANAGER) && (
            <ResponsiveButtonLink
              icon={<Edit />}
              to={
                organizationId
                  ? `/organization/${organizationId}/iter/${requirement.requirement_id}/edit`
                  : `/iter/${requirement.requirement_id}/edit`
              }
            >
              Edit
            </ResponsiveButtonLink>
          )}
        </Stack>
      }
    >
      <Box mt={2}>
        {requirement?.description && (
          <Box my={2}>
            <Typography variant="h6">Description</Typography>
            <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
              {requirement?.description}
            </Typography>
          </Box>
        )}
        <Box mb={2}>
          <DomainColorSquares requirement={requirement} size={14} />
        </Box>
        <Grid container spacing={2}>
          <Grid size={12}>
            <Box mt={2}>
              <CardOutline>
                <Box p={2}>
                  <Typography gutterBottom component="div" fontWeight={600}>
                    Competencies
                  </Typography>
                  {competencies.length === 0 && (
                    <Typography variant="body2" color="textSecondary">
                      No competencies
                    </Typography>
                  )}
                  {competencies.map((requirement) => (
                    <RequirementBox
                      key={requirement.requirement_id}
                      requirement={requirement}
                    />
                  ))}
                </Box>
              </CardOutline>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </MainLayoutContainer>
  );
};

